<template>
  <div class="flex items-center">
    <div v-if="alert === 'alert'">
      <vx-tooltip-with-slot-text position="top">
        <!-- ホバー時に表示するツールチップ -->
        <template v-slot:text>
          <div class="alert-tooltip-text z-10 aisea-text-14-400-white pl-1">
            <div class="alert-sub-title">24時間あたりの労働時間</div>
            <div class="alert">
              <span class="rect" :style="{ backgroundColor: `#F44336` }"></span>
              <span class="text ml-1">警告: 14時間超</span>
            </div>
          </div>
        </template>
        <!-- ホバー対象 -->
        <template v-slot:inner>
          <div>
            {{ hours }}
          </div>
        </template>
      </vx-tooltip-with-slot-text>
    </div>
    <div v-else-if="alert === 'warn'">
      <vx-tooltip-with-slot-text position="top">
        <!-- ホバー時に表示するツールチップ -->
        <template v-slot:text>
          <div class="alert-tooltip-text z-10 aisea-text-14-400-white pl-1">
            <div class="alert-sub-title">24時間あたりの労働時間</div>
            <div class="alert">
              <span class="rect" :style="{ backgroundColor: `#FFD54F` }"></span>
              <span class="text ml-1">注意: 10時間以上〜14時間以内</span>
            </div>
          </div>
        </template>
        <!-- ホバー対象 -->
        <template v-slot:inner>
          <div>
            {{ hours }}
          </div>
        </template>
      </vx-tooltip-with-slot-text>
    </div>
    <div v-else>
      {{ hours }}
    </div>
  </div>
</template>

<script>
import VxTooltipWithSlotText from "@/layouts/components/vx-tooltip/VxTooltipWithSlotText.vue";

export default {
  name: "CellRendererHoursOfRest",
  components: {
    VxTooltipWithSlotText,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    alert() {
      if (typeof this.params.value !== "number") return "none";
      if (this.params.is_hour_of_work24h_critical) return "alert";
      if (this.params.is_hour_of_work24h_warning) return "warn";
      return "none";
    },
    hours() {
      return this.getTimeFromMinutes(this.params.value);
    },
  },
  methods: {
    getTimeFromMinutes(minutes) {
      if (typeof minutes !== "number") return null;
      const hours = String(Math.floor(minutes / 60)).padStart(2, 0);
      const restMinuites = String(minutes % 60).padStart(2, 0);
      return `${hours}:${restMinuites}`;
    },
  },
};
</script>

<style lang="scss">
.alert-tooltip-text {
  .rect {
    border-radius: 2px;
    display: inline-block;
    width: 10px;
    height: 10px;
  }

  .rectcolor-alert {
    background-color: #eb5f56;
  }

  .rectcolor-warn {
    background-color: #ffbf00;
  }
}
</style>
